module.exports = __webpack_public_path__ + "media/recipes/91-366ed17d.png";